/*global getPersonAjaxUrlPrefix, $, window */
/****************************************
	relationshipcalculator.js
*****************************************/
$(function () {
	'use strict';
	$('.pageHeader').on('click', '.relLabel', function () {
		$('<div>').modal({
			'showLoading': true,
			'$trigger': $('#rel_label'),
			'width': '400',
			'onOpen': function ($this) {
				var ladderUrl = getPersonAjaxUrlPrefix() + '/tree/' + window.rcTid + '/person/' + window.rcPid + '/getladder';
				$.ajax({
					url: ladderUrl,
					async: true,
					type: 'GET',
					dataType: 'jsonp',
					contentType: 'application/json',
					success: function (response) {
						$.modal.showLoading(false);
						$this
							.html(
								'<div class="modalHasTitle">' +
									'<div class="modalHeader">' +
										'<div class="modalHeaderActions"><button class="icon iconPrint link" type="button">' + response.printText + '</button></div>' +
										'<h4 class="modalTitle">' + response.title + '</h4>' +
									'</div>' +
									response.html +
								'</div>'
							)
							.on('click', '.iconPrint', function () {
								/* Opens a print window to print the calculated relationship ladder */
								var printLadderUrl = getPersonAjaxUrlPrefix() + '/tree/' + window.rcTid + '/person/' + window.rcPid + '/printladder',
									printWindow = window.open(printLadderUrl, "PrintWindow", "width=750,height=850,top=50,left=50,toolbars=no,scrollbars=yes,status=no,resizable=yes");
								printWindow.focus();
							});
					},
					error: function (ex) {
						$.modal.showLoading(false);
						$this.html(
							'<div class="modalHasTitle">' +
								'<div class="modalHeader">' +
									'<h4 class="modalTitle">' + ex.title + '</h4>' +
								'</div>' +
								'<div>' +
									'<p>' + ex.html + '</p>' +
								'</div>' +
							'</div>'
						);
					}
				});
			}
		});
	});
});